type ErrorWithMessage = {
  message: string;
};

// A SilentTaskError is an error that can be thrown from within the app without triggering the error page
// It can be used within an Ember Concurrency task to silently fail so the task.isError property is correctly set to true
export default class SilentTaskError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SilentTaskError';
  }
}

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as Record<string, unknown>)['message'] === 'string'
  );
}

function toErrorWithMessage(maybeError: unknown): ErrorWithMessage {
  if (isErrorWithMessage(maybeError)) {
    return maybeError;
  }

  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    // fallback in case there's an error stringifying the maybeError
    // like with circular references for example.
    return new Error(String(maybeError));
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getErrorMessage(error: unknown) {
  return toErrorWithMessage(error).message;
}
